import React from 'react';
import ReferenceLayerDetailsForm from './ReferenceLayerDetailsForm';
import ConfirmDeleteReferenceLayerModal from '../../components/ConfirmDeleteReferenceLayerModal';

export default class ReferenceLayerDetails extends React.Component {
  static displayName = 'ReferenceLayerDetails';

  constructor(props) {
    super(props);
    this.state = {
      isSaving: false,
      isDeleting: false,
      showConfirmDeleteModal: false,
      errorMsg: undefined,
      successMsg: undefined
    };
    this.timeoutId = undefined;
  }

  componentDidMount() {
    const referenceLayerId = parseInt(this.props.params.referenceLayerId, 10);
    this.props.updateCurrentReferenceLayer(referenceLayerId);

    this.screenReaderContent.focus();
  }

  componentWillUnmount() {
    // clear timeout to prevent setState on unmounted component
    clearTimeout(this.timeoutId);
  }

  handleSubmit = values => {
    this.setState({ isSaving: true, errorMsg: undefined });
    if (values.id) {
      this.props.updateReferenceLayer(values).then(
        response => this.success(response),
        error => this.failure(error)
      );
    }
  };

  handleDeleteModalOPen = referenceLayerId => {
    this.setState({
      showConfirmDeleteModal: true
    });
  };

  handleDelete = () => {
    this.setState({
      isDeleting: true,
      errorMsg: undefined
    });

    this.props
      .deleteReferenceLayer(this.props.currentReferenceLayer.id)
      .then(
        response => {
          this.success(
            response,
            true,
            'Success! Reference Layer deleted, redirecting...'
          );
        },
        error => {
          this.failure(error);
        }
      )
      .finally(() => {
        this.closeModal();
      });
  };

  closeModal = () => {
    this.setState({
      isDeleting: false,
      showConfirmDeleteModal: false
    });
  };

  success = (response, redirect = false, successMsg = 'Success!') => {
    this.setState({
      isSaving: false,
      errorMsg: undefined,
      successMsg
    });
    this.timeoutId = setTimeout(() => {
      this.setState({ successMsg: undefined });
      if (redirect) {
        // TODO: make this dynamic - if so, scroll to top
        this.props.router.push(`/reference-layers`);
      }
    }, 3000);
  };

  failure = error => {
    this.setState({
      isSaving: false,
      isArchiving: false,
      errorMsg: error.data.message
    });
  };

  render() {
    const { currentReferenceLayer } = this.props;
    return (
      <div>
        <h3
          className="screen-reader-only"
          tabIndex="-1"
          ref={i => (this.screenReaderContent = i)}
        >
          Showing details for Reference Layer {currentReferenceLayer.label}
        </h3>
        <ReferenceLayerDetailsForm
          onSubmit={this.handleSubmit}
          initialValues={currentReferenceLayer}
          currentReferenceLayer={currentReferenceLayer}
          enableReinitialize={true}
          isSaving={this.state.isSaving}
          isDeleting={this.state.isDeleting}
          handleDelete={this.handleDeleteModalOPen}
          errorMsg={this.state.errorMsg}
          successMsg={this.state.successMsg}
          visibilityTypes={this.props.visibilityTypes}
        />
        <ConfirmDeleteReferenceLayerModal
          show={this.state.showConfirmDeleteModal}
          handleDelete={this.handleDelete}
          onHide={this.closeModal}
          isDeleting={this.state.isDeleting}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/referenceLayers/ReferenceLayerDetails.js